import {
  type TranscriptionMetadata,
  transcribeAudio,
} from "@elation/api-client/src/stitch-web";

export interface TranscribeVoiceInputAudioInput {
  audioBlob: Blob;
  metadata: TranscriptionMetadata;
  signal?: AbortSignal;
}

export interface TranscribeVoiceInputAudioResult {
  text: string;
  transcriptionId: string;
}

const VOICE_INPUT_AUDIO_FILENAME = "voice-input.webm";

export async function transcribeVoiceInputAudio({
  audioBlob,
  metadata,
  signal,
}: TranscribeVoiceInputAudioInput): Promise<TranscribeVoiceInputAudioResult> {
  const audioFile = new File([audioBlob], VOICE_INPUT_AUDIO_FILENAME, {
    type: audioBlob.type,
  });

  const result = await transcribeAudio(
    {
      file: audioFile,
      metadata: JSON.stringify(metadata),
      contentType: audioBlob.type || undefined,
    },
    { signal },
  );

  return {
    text: result.data.text,
    transcriptionId: result.data.transcriptionId,
  };
}
